import { observable, action, computed } from "mobx";
import { post } from "../services/ajax.service";

class GuaranteeStore {
  @observable total_spend = 0;
  @observable plan_pay = 0;
  @observable flag = false;
  @observable co_pay = 0;
  @observable total_claims = 0;
  @observable net_performance = 0;
  @observable net_performance_percentage = 0;
  @observable average_brand_discount = 0;
  @observable average_generic_discount = 0;
  @observable count = 0;
  @observable performance_table = [];
  @observable original_performance_data = [];
  @observable contracted_discount = {}
  @observable contracted_id = {}
  @observable net_performance_percentage = 0;
  @observable net_performance_dollar_amount = 0;
  @observable GuaranteeDrugs = []
  @observable GuaranteeDrugCount = 0
  @observable priceTypes = []
  @observable GuaranteePharmacies = [];
  @observable GuaranteePharmaciesCount = 0;
  @observable url = "/api/v1/performaneactions/guarantee";
  @observable price_types = [];
  @observable reprice_ids = [];
  @observable performanceTablePriceType = []
  @observable all_specialty = {};
  @observable net_performance_dollar_value_r = 0;
  @observable effective_discount = 0;
  @observable contracted_discount = 0;

  @computed get net_performance_dollar_value() {
    let performance = 0;
    for (let i of this.performance_table) {
      performance = performance + ((i.INGREDIENT_COST - (i.AWP * (1 - this.returnContractedDiscount(i.category) / 100))));
    }
    return performance
  }
  @computed get INGREDIENT_COST_TOTAL() {
    let ingredient = 0;
    for (let i of this.performance_table) {
      ingredient = ingredient + Number(i.INGREDIENT_COST)
    }
    return ingredient
  }

  @computed get net_performance_percentage_value() {
    let performance = 0
    let ingredient_cost = this.INGREDIENT_COST_TOTAL;
    let performance_dollar = this.net_performance_dollar_value;

    performance = performance + (performance_dollar / ingredient_cost);

    return performance * 100
  }
  @computed get tiles() {
    return parseInt(this.count / 100) > 0 ? parseInt(this.count / 100) + 1 : 0;
  }


  @computed get net_performance_value() {
    return (
      (parseInt(this.total_spend) / 100) *
      parseInt(this.net_performance_percentage)
    );
  }
  @action setFlag = (value) => {
    this.flag = value;
  }
  @action returnContractedDiscount = (type) => {
    if (this.contracted_discount[type]) {
      return this.contracted_discount[type];
    }
    else {
      return 0;
    }
  }
  @action getPerformance = async data => {
    try {
      let response = await post(
        `${this.url}/getPerformance`,
        data
      );

      this.net_performance_percentage = response.data[0].PERFORMANCE_CHANGE;
    } catch (err) {
      console.log(err);
    }
  };
  @action getPriceTypes = async data => {
    this.priceTypes = [];
    try {
      let response = await post(
        `${this.url}/getPriceTypes`,
        data
      );

      this.priceTypes = response.data;
    } catch (err) {
      console.log(err);
    }
  };
  @action getPerformanceTablePriceType = async data => {
    this.performanceTablePriceType = [];
    try {
      let response = await post(
        `${this.url}/getPerformanceTablePriceType`,
        data
      );

      this.performanceTablePriceType = response.data;
    } catch (err) {
      console.log(err);
    }
  };

  @action getTotalSpend = async data => {
    try {
      let response = await post(
        `${this.url}/getTotalSpend`,
        data
      );

      this.total_spend = response.data[0].TOTAL_SPEND;
      this.co_pay = response.data[0].co_pay;
      this.plan_pay = response.data[0].plan_pay;
    } catch (err) {
      console.log(err);
    }
  };
  @action getGuaranteeDrugs = async data => {
    this.GuaranteeDrugs = [];
    try {
      let response = await post(
        `${this.url}/getGuaranteeDrugs`,
        data
      );
      this.GuaranteeDrugs = response.data;
      if (data.price_type == "all") {
        let price_types = []
        response.data.map(d => {
          if (!price_types.includes(d.claim_type)) {
            price_types.push(d.claim_type)
          }

        }
        )
        this.price_types = price_types
      }
    } catch (err) {
      console.log(err);
    }
  };
  @action getGuaranteeDrugCount = async data => {
    this.GuaranteeDrugCount = [];
    try {
      let response = await post(
        `${this.url}/getGuaranteeDrugCount`,
        data
      );
      this.count = response.data[0].total_data;
    } catch (err) {
      console.log(err);
    }
  };
  @action getGuaranteePharmaciesCount = async data => {
    this.GuaranteePharmaciesCount = [];
    try {
      let response = await post(
        `${this.url}/getGuaranteePharmaciesCount`,
        data
      );
      this.count = response.data[0].total_data;
    } catch (err) {
      console.log(err);
    }
  };

  @action getGuaranteePharmacies = async data => {
    this.GuaranteePharmacies = [];
    try {
      let response = await post(
        `${this.url}/getGuaranteePharmacies`,
        data
      );

      this.GuaranteePharmacies = response.data;
      if (data.price_type == "all") {
        let price_types = []
        response.data.map(d => {
          if (!price_types.includes(d.claim_type)) {
            price_types.push(d.claim_type)
          }

        }
        )
        this.price_types = price_types
      }
    } catch (err) {
      console.log(err);
    }
  };

 
  @action generatePerformanceXlsxReport = async data => {
    this.reportError = "";
    try {
      let response = await post(
        `${this.url}/generateXlsxReport`,
        data
      );
      return true
    } catch (err) {
      this.reportError = err.response.data
      console.log(err);
    }
  };



  @action getTotalClaims = async data => {
    try {
      let response = await post(
        `${this.url}/getTotalClaims`,
        data
      );

      this.total_claims = response.data[0].TOTAL_CLAIMS;
    } catch (err) {
      console.log(err);
    }
  };

  @action getGenericDiscount = async data => {
    try {
      let response = await post(
        `${this.url}/getGenericDiscount`,
        data
      );

      this.average_generic_discount = response.data[0].AVERAGE_GENERIC_DISCOUNT;
    } catch (err) {
      console.log(err);
    }
  };

  @action getRepriceIds = async data => {
    try {
      let response = await post(
        `${this.url}/getRepriceIds`,
        data
      );

      this.reprice_ids = response.data;
      return response.data;
    } catch (err) {
      console.log(err);
    }
  };

  @action getBrandedDiscount = async data => {
    try {
      let response = await post(
        `${this.url}/getBrandedDiscount`,
        data
      );

      this.average_brand_discount = response.data[0].AVERAGE_BRANDED_DISCOUNT;
    } catch (err) {
      console.log(err);
    }
  };
  @action getContractedDiscount = async data => {
    try {
      let response = await post(
        `${this.url}/getContractedDiscount?type=${data.market_check? "market_check":""}`,
        data
      );
      if(data.performance_review=="reconciliation"){
this.effective_discount=response.data?.specialty_effective_discount
this.contracted_discount=response.data?.contract_sum
return;
      }
      this.contracted_discount = response.data[0] ? this.contracted_discount = response.data[0] : {};
    } catch (err) {
      console.log(err);
    }
  };

  @action getContractId = async data => {
    try {
      let response = await post(
        `${this.url}/getContractId`,
        data
      );
      this.contracted_id = response.data[0] ? this.contracted_id = response.data[0] : {};
    } catch (err) {
      console.log(err);
    }
  };


  @action getPerformanceTable = async data => {
    try {
      let specialty_data = { TOTAL_CLAIMS: 0, INGREDIENT_COST: 0, AWP: 0, category: 'S' }
      let response = await post(
        `${this.url}/getPerformanceTable`,
        data
      );
      if(data.performance_review == "reconciliation"){
        this.net_performance_dollar_value_r=response.data.net_performance;
        response.data.data.forEach(d => {
          if (d.filtered_category == "SB" || d.filtered_category == "SG") {
            specialty_data['TOTAL_CLAIMS'] += Number(d["TOTAL_CLAIMS"])
            specialty_data['INGREDIENT_COST'] += Number(d["INGREDIENT_COST"])
            specialty_data['AWP'] += Number(d["AWP"])
            specialty_data["category"] = "S"
            specialty_data["CATEGORY_NAME"] = "Specialty"
            specialty_data["effective_discount"] = ((specialty_data['AWP'] - specialty_data['INGREDIENT_COST']) / (specialty_data['AWP'])) * 100
          }
        })
        this.all_specialty = specialty_data
      this.performance_table = response.data.data;
      return response.data.data;

      }
else{
      response.data.forEach(d => {
        if (d.filtered_category == "SB" || d.filtered_category == "SG") {
          specialty_data['TOTAL_CLAIMS'] += Number(d["TOTAL_CLAIMS"])
          specialty_data['INGREDIENT_COST'] += Number(d["INGREDIENT_COST"])
          specialty_data['AWP'] += Number(d["AWP"])
          specialty_data["category"] = "S"
          specialty_data["CATEGORY_NAME"] = "Specialty"
          specialty_data["effective_discount"] = ((specialty_data['AWP'] - specialty_data['INGREDIENT_COST']) / (specialty_data['AWP'])) * 100

        }
      })
      this.all_specialty = specialty_data
      this.performance_table = response.data;
      return response.data;
    }
    
    } catch (err) {
      console.log(err);
    }
  };


  @action getPerformanceTableMarketCheck = async data => {
    try {
      let response = await post(
        `${this.url}/getPerformanceTableMarketCheck`,
        data
      );

      this.performance_table = response.data;
      this.performance_table.map(d => {
        this.original_performance_data = d.original_data
      }
      )


      return response.data;
    } catch (err) {
      console.log(err);
    }
  };
}



export default GuaranteeStore;
